import type { VariablesOf } from "@graphql-typed-document-node/core";
import { safe } from "pb.safe";

import { $, mutation } from "../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../shared/shared/api-client";

export function pairDevice({
	apiClient,
	...variables
}: { apiClient: ApiClient } & VariablesOf<typeof pairDevice.gql.pairDevice>) {
	return safe(() => apiClient.request(pairDevice.gql.pairDevice, variables));
}

pairDevice.gql = {
	pairDevice: mutation("pairDevice", (q) => [
		q.pairDevices({
			deviceUuid: $("deviceId"),
			input: [{ pairedDeviceUuid: $("terminalId"), override: true }],
		}),
	]),
};
